import * as sprite from 'client/icons/LocationTypes'

const LOCATION_TYPES = [
  { name: 'neighborhood', icon: sprite.iconLocation },
  { name: 'point_of_interest', icon: sprite.iconPOI },
  { name: 'city', icon: sprite.iconLocation },
  { name: 'zone', icon: sprite.iconLocation },
  { name: 'hotel', icon: sprite.iconHotel },
  { name: 'rural', icon: sprite.iconHotel },
  { name: 'homes', icon: sprite.iconHotel },
  { name: 'hostel', icon: sprite.iconHotel },
  { name: 'apartment', icon: sprite.iconHotel },
  { name: 'residence', icon: sprite.iconHotel },
  { name: 'camping', icon: sprite.iconHotel },
  { name: 'inn', icon: sprite.iconHotel },
  { name: 'bnb', icon: sprite.iconHotel },
  { name: 'villa', icon: sprite.iconHotel },
  { name: 'pending', icon: sprite.iconHotel },
  { name: 'motel', icon: sprite.iconHotel },
  { name: 'riad', icon: sprite.iconHotel },
  { name: 'botel', icon: sprite.iconHotel },
  { name: 'cruise', icon: sprite.iconHotel },
  { name: 'safari', icon: sprite.iconHotel },
  { name: 'treehouse', icon: sprite.iconHotel },
  { name: 'houseboat', icon: sprite.iconHotel },
  { name: 'train_station', icon: sprite.iconTrainStation },
  { name: 'bus_station', icon: sprite.iconBusTrainStation },
  { name: 'airport', icon: sprite.iconAirport },
]

export function getSuggestionIcon(type: string) {
  return (
    LOCATION_TYPES.find(locationType => locationType.name === type)?.icon || sprite.iconLocation
  )
}
